import React, {Component} from 'react';
import {connect} from 'react-redux';
import Message from "./MessageItem";


class MessageList extends Component {

    componentDidUpdate(_prevProps, _prevState) {
        this.scrollList.scrollTop = this.scrollList.scrollHeight;
    }

    render() {

        const {user} = this.props;

        return (
            <div className="sc-message-list" ref={el => this.scrollList = el}>
                {this.props.messages.map((message, i) => {
                    return <Message item={message} key={i} attachments={message.files} user={user}/>;
                })}
            </div>);
    }
}


export default connect(
    ({user}) => ({
        user: user.data,
    }),
)(MessageList);
